import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

// Components
import PublicRoute from './publicRoute';
import PrivateRoute from './privateRoute';
import Loader from '../components/utils/loader';

// Pages
import PageInvalidOffer from '../pages/invalidOffer';
import PageIdentify from '../pages/identify';

// Lazy loading components
import {
  PageUpdate,
  PageCart,
  PagePayment,
  PageNotFound,
  PageSubscriber,
  PagePaymentError,
  PagePaymentErrorRetry,
  PagePaymentErrorBlock,
  PagePaymentErrorLimit,
  PagePaymentErrorQarantine,
  PagePaymentSuccess,
  PagePaymentHalfSuccess,
} from './pages';

import { LOG } from '../helpers/utils';

class Routes extends Component {
  UNSAFE_componentWillMount() {
    const excepRoutes = [
      '/oferta-invalida',
      '/assinante',
      '/cadastro/confirmar-dados',
    ];
    excepRoutes.push('/identifique-se/');

    this.context.router.history.listen((location, action) => {
      LOG('[Routes] history', location, action);
      if (action === 'PUSH' && excepRoutes.indexOf(location.pathname) < 0) {
        setTimeout(() => {
          this.props.sendPageview();
        }, 300);
      }
    });
  }

  componentDidMount() {
    const path = this.context.router.route.location.pathname;
    // Set initial step
    this.props.setStep(path);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const path = this.context.router.route.location.pathname;

    // Redirect from all pages (except /oferta-invalida) if the offer is invalid
    if (nextProps.invalidOffer && path !== '/oferta-invalida') {
      this.context.router.history.push({
        pathname: '/oferta-invalida',
        search: this.props.params,
      });
    }

    // Redirect from all pages if the user is already a subscriber
    if (
      nextProps.isSubscriber &&
      !this.props.invalidOffer &&
      path !== '/assinante'
    ) {
      this.context.router.history.push({
        pathname: '/assinante',
        search: this.props.params,
      });
    }
  }

  componentDidUpdate() {
    const path = this.context.router.route.location.pathname;
    // Update step on route change
    if (this.props.path !== path) {
      this.props.setStep(path);
    }
  }

  render() {
    let component;
    if (!this.props.loadingUserAuthentication && !this.props.loadingUser) {
      const routeProps = {
        authenticated: this.props.authenticated,
        userAction: this.props.userAction,
        resetUserAction: this.props.resetUserAction,
        sessionCart: this.props.sessionCart,
        sendPageview: this.props.sendPageview,
        params: this.props.params,
      };
      component = (
        <Suspense fallback={<Loader show />}>
          <Switch>
            <Route
              exact
              path='/'
              {...routeProps}
              render={() => (
                <Redirect
                  to={{ pathname: '/revisao', search: this.props.params }}
                />
              )}
            />
            <Route
              exact
              path='/oferta'
              {...routeProps}
              render={() => (
                <Redirect
                  to={{ pathname: '/revisao', search: this.props.params }}
                />
              )}
            />
            <PublicRoute
              exact
              path='/identifique-se'
              {...routeProps}
              component={PageIdentify}
            />
            <PublicRoute
              exact
              path='/oferta-invalida'
              {...routeProps}
              component={PageInvalidOffer}
            />
            <PrivateRoute
              exact
              path='/assinante'
              {...routeProps}
              component={PageSubscriber}
            />
            <PrivateRoute
              exact
              path='/revisao'
              {...routeProps}
              component={PageCart}
            />
            <PrivateRoute
              exact
              path='/cadastro/confirmar-dados'
              {...routeProps}
              component={PageUpdate}
            />
            <PrivateRoute
              exact
              path='/pagamento'
              {...routeProps}
              component={PagePayment}
            />
            <PrivateRoute
              exact
              path='/pagamento/sucesso'
              {...routeProps}
              component={PagePaymentSuccess}
            />
            <PrivateRoute
              exact
              path='/pagamento/sucesso-pendente'
              {...routeProps}
              component={PagePaymentHalfSuccess}
            />
            <PrivateRoute
              exact
              path='/pagamento/erro'
              {...routeProps}
              component={PagePaymentError}
            />
            <PrivateRoute
              exact
              path='/pagamento/erro-retentativa'
              {...routeProps}
              component={PagePaymentErrorRetry}
            />
            <PrivateRoute
              exact
              path='/pagamento/erro-limite'
              {...routeProps}
              component={PagePaymentErrorLimit}
            />
            <PrivateRoute
              exact
              path='/pagamento/erro-bloqueio'
              {...routeProps}
              component={PagePaymentErrorBlock}
            />
            <PrivateRoute
              exact
              path='/pagamento/erro-quarentena'
              {...routeProps}
              component={PagePaymentErrorQarantine}
            />
            <PublicRoute path='*' component={PageNotFound} {...routeProps} />
          </Switch>
        </Suspense>
      );
    } else {
      component = (
        <div className='content-page'>
          <Loader show />
        </div>
      );
    }

    return component;
  }
}

Routes.defaultProps = {
  sendPageview: () => {},
};

Routes.propTypes = {
  sendPageview: PropTypes.func,
  sessionCart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  resetUserAction: PropTypes.func,
  setStep: PropTypes.func,
  invalidOffer: PropTypes.bool.isRequired,
  isSubscriber: PropTypes.bool,
  path: PropTypes.string.isRequired,
  loadingUserAuthentication: PropTypes.bool.isRequired,
  loadingUser: PropTypes.bool.isRequired,
  authenticated: PropTypes.bool.isRequired,
  userAction: PropTypes.any,
  params: PropTypes.string,
};

Routes.contextTypes = {
  router: PropTypes.object,
};

export default Routes;
